import React, { Component } from 'react';
import { Button, Form, InputGroup, FormText, FormControl, Table } from 'react-bootstrap';
import apiFetch from "../utils/apiFetch";
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPause, faPlay, faTrashAlt, faPen } from '@fortawesome/free-solid-svg-icons'

class Dashboard extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            albums: null
        }
        this.loadAlbums()
    }

    loadAlbums = () => {
        apiFetch('albums.get', {
            login: localStorage.getItem('login'),
            password: localStorage.getItem('password')
        }).then((result) => {
            console.log(result);
            if (!result.success) {
                this.setState({need_login: true});
                window.location.replace("/auth");
            } else {
                console.log('auth is okey')
                this.setState({albums: result.items})
            }
        })
    }

    albumSetActive = (album_id) => {
        let albums = this.state.albums;
        let album_key = 0;
        albums.forEach((album, key) => {
            if (album.id == album_id) {
                album_key = key;
            }
        });
        console.log(album_key);
        apiFetch('albums.setActive', {
            album_id: album_id,
            active: !albums[album_key].active
        }).then((result) => {
            //console.log(result);
            //console.log(albums);
            albums[album_key].active = !albums[album_key].active;
            this.setState({albums: albums});
        });

    }

    albumDelete = (album_id) => {
        if(confirm('Вы действительно хотите удалить?')) {
            let albums = this.state.albums;
            let album_key = 0;
            albums.forEach((album, key) => {
                if (album.id == album_id) {
                    album_key = key;
                }
            });
            console.log(album_key);
            apiFetch('albums.delete', {
                album_id: album_id
            }).then((result) => {
                albums.splice(album_key, 1);
                this.setState({albums: albums});
            });
        }

    }

    render() {
        return (
            <React.Fragment><h2>Альбомы</h2>
                <Link to="/album/add"><Button variant="primary">Добавить альбом</Button></Link>

                <hr/>
                <Table striped bordered hover>
                    <thead>
                    <tr>
                        <th>Ссылка на альбом</th>
                        <th>Приоритет</th>
                        <th>Кол-во фото в альбоме</th>
                        <th>Контакты фотографа</th>
                        <th>Действия</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.albums && this.state.albums.map((album) => {
                        let edit_link = '/album/edit/'+album.id;
                        let priority = '';
                        switch (album.priority) {
                            case 0: priority = 'Низкий'; break;
                            case 1: priority = 'Средний'; break;
                            case 2: priority = 'Высокий'; break;
                        }
                        return <React.Fragment>{album ? <tr key={album.id}>

                            <td>{album.album_link}</td>
                            <td>{priority}</td>
                            <td>{album.photos_count}</td>
                            <td>{album.photographer_contact}</td>
                            <td>
                                {album.active ? <FontAwesomeIcon onClick={() => this.albumSetActive(album.id)} icon={faPause}/> : <FontAwesomeIcon onClick={() => this.albumSetActive(album.id)} icon={faPlay}/>}
                                <Link to={edit_link}><FontAwesomeIcon icon={faPen}/></Link>
                                <FontAwesomeIcon onClick={() => this.albumDelete(album.id)} icon={faTrashAlt}/>
                                </td>
                        </tr> : null }</React.Fragment>
                    })}
                    </tbody>
                </Table>
            </React.Fragment>
        );
    }
}

export default withRouter(Dashboard);



// WEBPACK FOOTER //
// ./src/components/Dashboard.js